import axios from 'axios';
import { redirectTo } from './utils';

export const createAxios = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status || 500;
      if (status === 401 || status === 403) {
        redirectTo('/login');
        return Promise.reject(error); // Ensure we still reject the promise after redirect
      }
      return Promise.reject(error);
    }
  );

  return instance;
}
